import axios from "axios";

export async function fetchPupilsByTargetGroup(groupId) {
    try {
        const response = await axios.get(`/targetGroups/level2/${groupId}/pupils`);
        return response.data;
    } catch (e) {
        const text = e.response?.data?.message || "Ошибка загрузки учеников";
        throw new Error(text);
    }
}
